import { color } from "@jdh/laputa-interface";
import axios from "axios";
import Cookie from "js-cookie";

const isDev = process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com";

const localHeader = {
  Authorization: Cookie.get("xxtj_requestToken") || "",
  "Selected-Tenant": Cookie.get("xxtj_userTenantId"),
  "Selected-Org": Cookie.get("xxtj_userOrgId"),
};

// 查询枚举列表
export const health_pcs_cat_options = (params) =>
  color("health_pcs_cat_options", params, "post", {
    appid: "health-bianque-man",
    // docId: '9414',
    isDev: isDev,
    loginType: 7,
  });

// 案例列表查询
export const health_pcs_caseDetail_list = (params) =>
  color("health_pcs_caseDetail_list", params, "post", {
    appid: "health-bianque-man",
    // docId: '9702',
    isDev: isDev,
    loginType: 7,
  });

// 案例置顶 & 取消
export const health_pcs_caseDetail_setPinned = (params) =>
  color("health_pcs_caseDetail_setPinned", params, "post", {
    appid: "health-bianque-man",
    // docId: '9710',
    isDev: isDev,
    loginType: 7,
  });

// 案例删除
export const health_pcs_caseDetail_delete = (params) =>
  color("health_pcs_caseDetail_delete", params, "post", {
    appid: "health-bianque-man",
    // docId: '9714',
    isDev: isDev,
    loginType: 7,
  });

// 案例编辑
export const health_pcs_caseDetail_update = (params) =>
  color("health_pcs_caseDetail_update", params, "post", {
    appid: "health-bianque-man",
    // docId: '9720',
    isDev: isDev,
    loginType: 7,
  });

// 案例回显
export const health_pcs_caseDetail_findById = (params) =>
  color("health_pcs_caseDetail_findById", params, "post", {
    appid: "health-bianque-man",
    // docId: '9720',
    isDev: isDev,
    loginType: 7,
  });

/**
 * 上传图片
 */
export const uploadFile = (file) => {
  return new Promise((resolve, reject) => {
    let formdata = new FormData();
    formdata.append("file", file);
    //设置请求头
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        ...localHeader,
      },
    };
    const axiosAjax = axios.create({
      timeout: 1000 * 60,
      withCredentials: false,
    });
    let devUploadUrl = "/boss/diagnosis/word/rule/uploadRulesByExcel"; //预发上传
    let proUploadUrl = "/boss/diagnosis/word/rule/uploadRulesByExcel"; //线上上传
    let imgUploadUrl =
      process.env.NODE_ENV === "development" ? devUploadUrl : proUploadUrl;
    axiosAjax
      .post(imgUploadUrl, formdata, config)
      .then((res) => {
        console.log(res);
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
